import type { UnitIdInRangeByHash } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface Props {
  value: UnitIdInRangeByHash;
  onChange: (value: UnitIdInRangeByHash) => void;
}

export function UnitIdInRangeByHashFilter({ value, onChange }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2">
      <div>
        <Label className="text-[10px] text-overlay1 mb-1 block">Hash Key</Label>
        <Input
          value={value.hash_key}
          onChange={(e) => onChange({ ...value, hash_key: e.target.value })}
          placeholder="hash_key"
          className="h-8 text-xs"
        />
      </div>
      <div>
        <Label className="text-[10px] text-overlay1 mb-1 block">Start Ring</Label>
        <Input
          type="number"
          value={value.start_ring_position}
          onChange={(e) => onChange({ ...value, start_ring_position: parseInt(e.target.value) || 0 })}
          className="h-8 text-xs"
        />
      </div>
      <div>
        <Label className="text-[10px] text-overlay1 mb-1 block">Stop Ring</Label>
        <Input
          type="number"
          value={value.stop_ring_position}
          onChange={(e) => onChange({ ...value, stop_ring_position: parseInt(e.target.value) || 0 })}
          className="h-8 text-xs"
        />
      </div>
    </div>
  );
}
